import { Route } from "react-router-dom";
import lazyRoute from "@/router/lazy-route";
import { PatientFlagList } from "@/router/provider-portal-router/provider-lazy-routes";

const ProviderRolesAndResponsibility = lazyRoute(
  () => import("@/components/app/settings/ProviderRolesAndResponsibility")
);
const ProviderGroupPatients = lazyRoute(
  () => import("@/pages/app/ProviderGroupPatients")
);
const ProviderGroupDepartments = lazyRoute(
  () => import("@/pages/app/admin/provider-groups/ProviderGroupDepartments")
);
const ProviderGroupLocations = lazyRoute(
  () => import("@/pages/app/admin/provider-groups/ProviderGroupLocations")
);
const ProviderGroupProfile = lazyRoute(
  () => import("@/pages/app/admin/provider-groups/ProviderGroupProfile")
);
const AuditLog = lazyRoute(() => import("@/pages/app/admin/settings/AuditLog"));
const SettingsLayout = lazyRoute(
  () => import("@/pages/app/provider/settings/SettingsLayout")
);
const AccountSettings = lazyRoute(
  () => import("@/pages/app/provider/settings/account-setting/AccountSettings")
);
const ProviderGroupAppoinmentType = lazyRoute(
  () => import("@/pages/app/admin/provider-groups/ProviderGroupAppoinmentType")
);
const UserSettingsLayout = lazyRoute(
  () => import("@/layout/app/admin/UserSettingsLayout")
);
const ProviderConfig = lazyRoute(
  () => import("@/pages/app/provider/settings/ProviderConfig")
);
const FlagList = lazyRoute(
  () => import("@/pages/app/provider/settings/flag-setting/FlagList")
);
const FlagSettingtLayout = lazyRoute(
  () => import("@/pages/app/provider/settings/flag-setting/FlagSettingtLayout")
);
const PracticeSettingLayout = lazyRoute(
  () =>
    import("@/pages/app/provider/settings/practice-setting/PracticeSettingLayout")
);
const PrintConfiguration = lazyRoute(
  () =>
    import("@/pages/app/provider/settings/practice-setting/PrintConfiguration")
);
const ProviderUserDetails = lazyRoute(
  () =>
    import("@/pages/app/provider/settings/practice-setting/ProviderUserDetails")
);
const UserDetails = lazyRoute(
  () => import("@/pages/app/provider/settings/practice-setting/UserDetails")
);
const PatientIdConfiguration = lazyRoute(
  () =>
    import("@/pages/app/provider/settings/practice-setting/patient-id-config/PatientIdConfiguration")
);

export const SettingsRoutes = () => (
  <Route path="settings" element={<SettingsLayout />}>
    <Route path="account-settings" element={<AccountSettings />} />
    {/* <Route path="flag-settings" element={<FlagList />} /> */}
    <Route path="flag-settings" element={<FlagSettingtLayout />}>
      <Route index element={<FlagList />} />
      <Route path="patient-flag-settings" element={<PatientFlagList />} />
    </Route>

    <Route path="practice-settings" element={<PracticeSettingLayout />}>
      <Route index element={<ProviderGroupProfile />} />
      <Route path="locations" element={<ProviderGroupLocations />} />
      <Route path="departments" element={<ProviderGroupDepartments />} />
      <Route path="patients" element={<ProviderGroupPatients />} />
      <Route path="print-configuration" element={<PrintConfiguration />} />
      <Route path="configuration" element={<ProviderConfig />} />
      <Route
        path="appointment-type-configuration"
        element={<ProviderGroupAppoinmentType />}
      />
      {/* <Route path="configuration" element={<ClaimIntegrationList />} /> */}
      <Route path="audit-log" element={<AuditLog />} />
      <Route
        path="patient-id-configuration"
        element={<PatientIdConfiguration />}
      />
    </Route>
    <Route path="user-settings" element={<UserSettingsLayout />}>
      <Route index element={<UserDetails />} />
      <Route path="provider-users" element={<ProviderUserDetails />} />
      <Route
        path="role-responsibility"
        element={<ProviderRolesAndResponsibility />}
      />
    </Route>
  </Route>
);
